if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');

        // 初始化箭头功能
        this.initThumbnailArrows();

        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      ////////////////////// 桌面端箭头显示逻辑 //////////////////////
      initThumbnailArrows() {
        // 为所有图片的箭头绑定事件
        this.bindArrowEvents();

        // 初始化箭头状态
        this.updateArrowsVisibility();
      }

      bindArrowEvents() {
        // 获取所有箭头按钮并绑定事件
        this.elements.viewer.querySelectorAll('[data-thumbnail-prev]').forEach((arrow) => {
          arrow.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.goToPrevious();
          });
        });

        this.elements.viewer.querySelectorAll('[data-thumbnail-next]').forEach((arrow) => {
          arrow.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.goToNext();
          });
        });
      }

      getCurrentMediaIndex() {
        const activeMedia = this.elements.viewer.querySelector('.product__media-item.is-active');
        if (!activeMedia) return 0;

        const allMediaItems = Array.from(this.elements.viewer.querySelectorAll('.product__media-item'));
        return allMediaItems.indexOf(activeMedia);
      }

      getAllVisibleMediaItems() {
        return Array.from(this.elements.viewer.querySelectorAll('.product__media-item'));
      }

      goToPrevious() {
        const mediaItems = this.getAllVisibleMediaItems();
        const currentIndex = this.getCurrentMediaIndex();
        const prevIndex = currentIndex > 0 ? currentIndex - 1 : mediaItems.length - 1;

        const targetMedia = mediaItems[prevIndex];
        if (targetMedia) {
          const mediaId = targetMedia.dataset.mediaId;
          this.setActiveMedia(mediaId, false);
        }
      }

      goToNext() {
        const mediaItems = this.getAllVisibleMediaItems();
        const currentIndex = this.getCurrentMediaIndex();
        const nextIndex = currentIndex < mediaItems.length - 1 ? currentIndex + 1 : 0;

        const targetMedia = mediaItems[nextIndex];
        if (targetMedia) {
          const mediaId = targetMedia.dataset.mediaId;
          this.setActiveMedia(mediaId, false);
        }
      }

      updateArrowsVisibility() {
        const mediaItems = this.getAllVisibleMediaItems();
        const arrows = this.elements.viewer.querySelectorAll('.product-thumbnail-arrow');

        // 如果只有一个媒体项，隐藏所有箭头
        if (mediaItems.length <= 1) {
          arrows.forEach((arrow) => arrow.classList.add('hidden'));
          return;
        }
        // 显示所有箭头
        arrows.forEach((arrow) => arrow.classList.remove('hidden'));
      }
      ////////////////////// 桌面端箭头显示逻辑 //////////////////////

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`,
        );
        this.setActiveThumbnail(thumbnail);
        // 更新箭头状态
        this.updateArrowsVisibility();
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        // 注释掉或删除重排序逻辑，保持原有顺序
        /*
        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail &&
              activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }
          */

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);

        // 更新箭头状态
        this.updateArrowsVisibility();
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    },
  );
}
